import React, { useState, useEffect } from 'react';
import PhoneShell from './PhoneShell';

export default function TryRobotPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [analysisKey, setAnalysisKey] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);

  // عد تنازلي 6 ساعات (21600 ثانية)
  useEffect(() => {
    const savedStart = localStorage.getItem('discountStart');
    const now = Date.now();

    let startTime = savedStart ? parseInt(savedStart) : now;
    // التأكد من أن العداد يبدأ من جديد إذا مر أكثر من 6 ساعات (21600000 ميلي ثانية)
    if (now - startTime >= 21600000) {
      startTime = now;
      localStorage.setItem('discountStart', now.toString());
    }

    const updateTimer = () => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = 21600 - elapsed;
      setTimeLeft(remaining > 0 ? remaining : 0);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, '0')}:${mins
      .toString()
      .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleAnalyze = () => {
    setIsLoading(true);

    setTimeout(() => {
      setAnalysisKey((prev) => prev + 1);
      setIsLoading(false);
    }, 4000);
  };

  return (
    <div className="flex flex-col items-center gap-6 w-full font-poppins text-center">
      
      {/* عرض الهاتف */}
      <div className="w-full max-w-sm">
        <PhoneShell isLoading={isLoading} analysisKey={analysisKey} />
      </div>

      {/* رسالة المحاكاة الجديدة */}
      <div className="w-full max-w-sm px-4">
        <div className="p-3 text-sm rounded-lg bg-[#0a1429] border border-yellow-500/50 shadow-[0_0_10px_#facc1533]">
          <p className="text-yellow-300 font-semibold mb-1 flex items-center justify-center gap-2">
            <i className="bx bxs-error text-base"></i>
            <span>تنبيه هام!</span>
          </p>
          <p className="text-gray-300">
            هذا العرض هو *محاكاة* لشكل ونتائج الروبوت. هذه **ليست** صفقات تداول حقيقية بل محاكاة كنوع من التجربة قبل الاشتراك.
          </p>
        </div>
      </div>
      {/* نهاية رسالة المحاكاة */}

      {/* زر تحليل السوق */}
      <button
        onClick={handleAnalyze}
        disabled={isLoading}
        className="w-[70%] max-w-[220px] inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#22ff9b] to-[#1de48b] text-[#060c1f] py-2.5 px-5 rounded-lg font-black uppercase tracking-wider shadow-[0_0_14px_#22ff9b55] disabled:opacity-50 disabled:cursor-not-allowed transition-transform hover:scale-105"
      >
        {isLoading ? (
          <>
            <i className="bx bx-loader-alt animate-spin text-lg"></i>
            <span>جاري التحليل...</span>
          </>
        ) : (
          <>
            <i className="bx bxs-zap text-lg"></i>
            <span>تحليل السوق</span>
          </>
        )}
      </button>

      {/* عداد بريميوم */}
      <div className="relative mt-2 px-4 py-2 rounded-xl bg-[#0a1429] shadow-[0_0_12px_#22ff9b33] border border-[#1de48b33]">
        <span className="text-sm text-[#22ff9b] font-semibold">
          خصم <span className="text-yellow-300 text-lg font-bold">40%</span> لمدة
        </span>
        <div className="text-[#00ffe0] text-2xl font-mono font-bold mt-1 drop-shadow-[0_0_6px_#00ffe055]">
          ⏳ {formatTime(timeLeft)}
        </div>
      </div>

      {/* زر الاشتراك */}
      <a
        href="https://t.me/m/TAvESO-WMDFk"
        target="_blank"
        rel="noopener noreferrer"
        className="w-[70%] max-w-[220px] inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#00ffe0] to-[#00bfa5] text-[#060c1f] font-extrabold py-3 rounded-lg tracking-wider shadow-[0_0_18px_#00ffe044] hover:scale-105 transition-transform"
      >
        <i className="bx bxs-bot text-xl"></i>
        اشترك الآن بالروبوت
      </a>
    </div>
  );
}